import { useEffect, useState } from 'react';

import {
  getScreenOrientation,
  isScreenOrientationSupported,
} from '../../utils/screenOrientation';

import type { OrientationType } from '../../utils/screenOrientation';

export const addOrientationChangeListener = (
  listener: (orientation: OrientationType) => void
) => {
  let currentOrientation = getScreenOrientation();

  const handler = () => {
    const newOrientation = getScreenOrientation();

    if (currentOrientation === newOrientation) {
      return;
    }

    currentOrientation = newOrientation;

    listener(currentOrientation);
  };

  if (isScreenOrientationSupported) {
    window.screen.orientation.addEventListener('change', handler, {
      passive: true,
    });
  } else {
    window.addEventListener('orientationchange', handler, { passive: true });
  }

  return () => {
    if (isScreenOrientationSupported) {
      window.screen.orientation.removeEventListener('change', handler);
    } else {
      window.removeEventListener('orientationchange', handler);
    }
  };
};

export function useDeviceOrientation() {
  const [orientation, setOrientation] = useState(() => getScreenOrientation());

  useEffect(() => {
    const unsubscribe = addOrientationChangeListener(setOrientation);

    return () => unsubscribe();
  }, []);

  return orientation;
}
